var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticStyle:{"height":"100vh","width":"100%","border":"none","overflow":"hidden"},attrs:{"src":_vm.htmllink,"width":"100%","height":"100%","onload":"javascript:(function(o){o.style.height=o.contentWindow.document.body.scrollHeight+50+\"px\";}(this));"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }